import { render, staticRenderFns } from "./LomPresidentList.vue?vue&type=template&id=2382f196"
import script from "./LomPresidentList.vue?vue&type=script&lang=js"
export * from "./LomPresidentList.vue?vue&type=script&lang=js"
import style0 from "./LomPresidentList.vue?vue&type=style&index=0&id=2382f196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports